module.exports = __webpack_public_path__ + "static/media/1025879.02a58675.jpg";